/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

/**
 * * `owner` - Owner
 * * `admin` - Admin
 * * `employee` - Employee
 */
export enum OrganizationRole {
  OWNER = 'owner',
  ADMIN = 'admin',
  EMPLOYEE = 'employee',
}
